/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Mass email campaign progress
 * @export
 * @interface CampaignProgressResponse
 */
export interface CampaignProgressResponse {
    /**
     * Number of emails sent so far
     * @type {number}
     * @memberof CampaignProgressResponse
     */
    sent?: number;
    /**
     * Total number of recipients
     * @type {number}
     * @memberof CampaignProgressResponse
     */
    total?: number;
    /**
     * Status: RUNNING, PAUSED, CANCELLED, COMPLETED
     * @type {string}
     * @memberof CampaignProgressResponse
     */
    status?: string;
    /**
     * Current batch index (1-based)
     * @type {number}
     * @memberof CampaignProgressResponse
     */
    currentBatch?: number;
    /**
     * Error message if any
     * @type {string}
     * @memberof CampaignProgressResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the CampaignProgressResponse interface.
 */
export function instanceOfCampaignProgressResponse(value: object): value is CampaignProgressResponse {
    return true;
}

export function CampaignProgressResponseFromJSON(json: any): CampaignProgressResponse {
    return CampaignProgressResponseFromJSONTyped(json, false);
}

export function CampaignProgressResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CampaignProgressResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sent': json['sent'] == null ? undefined : json['sent'],
        'total': json['total'] == null ? undefined : json['total'],
        'status': json['status'] == null ? undefined : json['status'],
        'currentBatch': json['currentBatch'] == null ? undefined : json['currentBatch'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function CampaignProgressResponseToJSON(json: any): CampaignProgressResponse {
    return CampaignProgressResponseToJSONTyped(json, false);
}

export function CampaignProgressResponseToJSONTyped(value?: CampaignProgressResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sent': value['sent'],
        'total': value['total'],
        'status': value['status'],
        'currentBatch': value['currentBatch'],
        'error': value['error'],
    };
}

